import { render, staticRenderFns } from "./KPICard.vue?vue&type=template&id=5cb0ee0f&scoped=true"
import script from "./KPICard.vue?vue&type=script&lang=js"
export * from "./KPICard.vue?vue&type=script&lang=js"
import style0 from "./KPICard.vue?vue&type=style&index=0&id=5cb0ee0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0ee0f",
  null
  
)

export default component.exports